"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ArbitrumRelayerFee_1 = require("./ArbitrumRelayerFee");
const models_1 = require("../models");
class RelayerFee {
    constructor(network, token) {
        this.relayerFee = {};
        this.relayerFee[models_1.Chain.Arbitrum.slug] = new ArbitrumRelayerFee_1.ArbitrumRelayerFee(network, token);
    }
    async getRelayCost(chainSlug) {
        return this.relayerFee[chainSlug].getRelayCost();
    }
}
exports.default = RelayerFee;
